/**
 * Shared constants
 */

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    SIGNUP: '/auth/signup',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
    GET_UI_CONFIG: '/tenant/ui/single/config',
    CHECK_USER: '/auth/user',
    SEND_OTP: '/auth/otp/send',
    VERIFY_OTP: '/auth/otp/verify',
    RESET_PASSWORD: '/auth/password/reset',
  },
  POSTS: {
    LIST: '/posts',
    DETAIL: (id: number) => `/posts/${id}`,
    CREATE: '/posts',
    UPDATE: (id: number) => `/posts/${id}`,
    PATCH: (id: number) => `/posts/${id}`,
    DELETE: (id: number) => `/posts/${id}`,
  },
  USERS: {
    GET_USERS: '/tenants/users?is_active=',
    TOGGLE_ACTIVE: (id: string | number) => `/tenants/users/${id}/toggle-active`,
  },
  ROLES: {
    GET_ROLES: '/tenants/rbac/roles',
    TOGGLE_ACTIVE: (id: string | number) => `/tenants/rbac/roles/${id}/toggle-active`,
    MODULES_FEATURES: '/tenants/rbac/modules-features',
    MODULES: '/tenants/rbac/modules',
    MODULE_FEATURES: (moduleId: number | string) => `/tenants/rbac/modules/${moduleId}/features`,
    PERMISSIONS: '/tenants/rbac/permissions',
    CREATE_BULK: '/tenants/rbac/access/bulk',
    MODULE_CONFIG: (userId: string | number) => `/tenants/rbac/users/${userId}/module-config`,
    MODULE_CONFIG_SAVE: '/tenants/rbac/module-config',
    USER_ROLE: '/tenants/rbac/user-role',
  },
  UPLOADS: {
    IMAGES: '/uploads/images',
  },
} as const

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  AUTH_TOKEN_EXPIRES_AT: 'auth_token_expires_at',
  REFRESH_TOKEN: 'refresh_token',
  REFRESH_TOKEN_EXPIRES_AT: 'refresh_token_expires_at',
  USER: 'user',
  LOGIN_CREDENTIALS: 'login_credentials',
  AUD_PERSONA: 'akashic-aud-persona',
  AUD_ROLE: 'akashic-aud-role',
  AUD_SIDEBAR_COLLAPSED: 'akashic-aud-sidebar-collapsed',
  AUD_TOUR_COMPLETED: 'akashic_adp_tour_completed',
} as const

export const QUERY_KEYS = {
  AUTH: {
    ME: ['auth', 'me'] as const,
  },
} as const

